import React, {useState, useEffect} from 'react';
import GeoGebraP from '../components/GeoGebraP';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import GetProblemInfo from '../components/GetProblemInfo';
import ProblemStatDescription from '../components/ProblemStatDescription';
import useAuth from '../hooks/useAuth';
import UserSolvingStat from '../components/UserSolvingStat';
import { VscCheck,VscRocket } from "react-icons/vsc";
import axiosapi from "../api/axiosapi";
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

const CategoryProblem = ()=> {
    const {categoryURL, categoryTitle, problemCode} = useLocation().state;
    const {auth, setAuth} = useAuth();
    const navigateto=useNavigate();
    const location = useLocation();
    const [category, setCategory] = useState('');
    const [count, setCount] = useState(0);
    const {problem, problemPoemTitle, problemPoem, errP} = GetProblemInfo({"problemID": problemCode});
    const [images, setImages] = useState([]);
    const {useStat} = UserSolvingStat({"problemCode": problemCode});
    const [isPoem, setIsPoem] = useState(false);
    const [showPoem, setShowPoem] = useState(false);
    const [loading, setLoading] = useState(true);
    const [problemOrder, setProblemOrder] = useState();

    const splitContent = (sentence) => {
        const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
        const matches = sentence.matchAll(InlineMathRegex);
        let lastIndex = 0;
        const contentArray = [];
        
        for (const match of matches) {
            const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
            const restOfContent = sentence.substring(lastIndex, match.index);
        
            contentArray.push(restOfContent, InlineMathContent);
            lastIndex = match.index + match[0].length;
        }
        
        if (lastIndex < sentence.length) {
            contentArray.push(sentence.substring(lastIndex));
        }
        
        return <div>{contentArray}</div>;
    };

    useEffect(()=> {
        let isMounted = true;
        const controller = new AbortController();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchCategoryList = async () => {
            try {
                const response = await axiosapi.get('/category/problem/all/door/', {
                    params: {
                        url: categoryURL
                    },
                    withCredentials: true
                })
                isMounted && response.data && setCategory(response.data);
                isMounted && response.data && setCount(count+1);
            } catch (err) {
                console.log(err);
            }
        }

        fetchCategoryList()

        return () => {
            isMounted = false;
            controller.abort();
        }
    },[categoryURL]);

    useEffect(() => {
        const poemSetting = () => {
            problemPoem && problemPoem.length > 1 ? setIsPoem(true) : setIsPoem(false)
        }

        const imagesSetting = () => {
            setImages([]);
            problem.images && problem.images.map(image => {
                setImages(prev => [...prev, image]);
            })
        }

        setShowPoem(false);

        poemSetting();
        imagesSetting();
    },[problemPoemTitle, problemPoem]);

    useEffect(() => {
        category && category.map(problem => {
            if (problem.problemCode === problemCode) {
                setProblemOrder(problem.problemOrder);
            }
        })
    },[problemCode]);

    // console.log("categoryURL: ", categoryURL);
    // console.log("category: ", category);
    // console.log("problem: ", problemCode);
    // console.log("problem order: ", problemOrder);

    function ProblemLinkC ({LinkTitle, LinkId}) {
        return(
            <div className="subject-sidebar-4">
                {LinkId === problemCode
                    ? <b style ={{color:'red'}}>{LinkTitle} <VscCheck/> <VscRocket/></b>
                    : <Link to={`/door/category/problem/`} state={{
                                "categoryURL": categoryURL,
                                "categoryTitle": categoryTitle,
                                "problemCode": LinkId
                            }}>
                                {LinkTitle}
                        </Link>
                }
            </div>
        )
    }

    function ProblemLink ({LinkTitle, LinkId}) {
        return(
            <div className="subject-sidebar-4">
                <Link to={`/door/category/problem/`} state={{
                        "categoryURL": categoryURL,
                        "categoryTitle": categoryTitle,
                        "problemCode": LinkId
                    }}>
                        {LinkTitle}
                </Link>
            </div>
        )
    }

    if (errP) {
        return (
            <div className="problem">
                <p>"문제를 다운로드하지 못했습니다. 다시 시도해 주세요."</p>
                <button 
                    className='button'
                    onClick={() => navigateto(-1, {replace: true})}
                >
                    이전화면으로 돌아가기
                </button>
            </div>
        )
    } else if (auth?.accessToken === null && problemOrder > 2) {
        return (
            <div className="problem">
                {navigateto("/login", {state:{"from": location}}, {replace: true})}
            </div>
        )
    } else {
        return(
            <div className="App-full-row-container" key={problem.problemCode}>
                <div className="left-menu-box-1">
                    <h4 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px", marginLeft:"5px"}}>
                        {categoryTitle}
                    </h4>
                    {
                        category && category.map(problem => {
                            return(
                                <div key={problem.problemCode}>
                                    {problem.problemCode === problemCode
                                        ? <ProblemLinkC LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} /> 
                                        : <ProblemLink LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className="content-box-1">
                    <div className="problem">
                        <div style={{minWidth: "400px"}}></div>
                        <div className="content-fit">
                            <ProblemStatDescription 
                                topCategoryTitle={categoryTitle}
                                problemTitle={problem.problemTitle} 
                                problemDescription={problem.problemDescription}
                                problemId={problem.problemCode}
                                useStat={useStat}
                                problemType={problem.problemType}
                                maxPoint={problem.maxPoint}
                            />
                            {problem && <GeoGebraP
                                title={problem.problemTitle}
                                idIn={problem.problemCode}
                                customToolBarIn={problem.customToolBar}
                                allowStyleBarIn={problem.allowStyleBar}
                                ggbBase64In={problem.problemContent}
                                problemType={problem.problemType}
                                showToolBarHelpIn={problem.showToolBarHelp}
                                enableLabelDragIn={problem.enableLabelDrag}
                                enableShiftDragZoomIn={problem.enableShiftDragZoom}
                            />}
                            <div className='horizontal-flex-container'>
                                {(problem.problemType === 1 || problem.problemType === 2 || problem.problemType === 4 || problem.problemType === 6 || problem.problemType === 7 || problem.problemType === 701 || problem.problemType === 10 || problem.problemType === 11 || problem.problemType === 12)
                                    ? <button 
                                            className='button'
                                            onClick={
                                                () => auth?.accessToken
                                                    ? navigateto(`/door/category/problem/my/s/list`, {state:{
                                                        "categoryURL": categoryURL,
                                                        "categoryTitle": categoryTitle,
                                                        "problemCode": problemCode,
                                                        "problem": problem,
                                                        "category": category
                                                    }})
                                                    : navigateto("/login", {state:{"from": location}}, {replace: true})
                                            }
                                        >
                                            내 풀이보기
                                        </button>
                                    : null
                                }
                                {isPoem && <button
                                        className='button'
                                        onClick={() => setShowPoem(prev => !prev)}
                                    >
                                        {showPoem ? '시적인 확장 감추기' : '시적인 확장 보기'}
                                    </button>
                                }
                                {/* {images.length > 0 && <button 
                                        className='button'
                                        onClick={() => navigateto(`/mathsubject/image/list/`, {state:{
                                            "subjectCode": subjectCode,
                                            "problemCode": problemCode,
                                            "subjectTitle": subjectTitle,
                                            "firstProbID": firstProbIDSample,
                                            "problemTitle": problem.problemTitle,
                                            "images": images,
                                            "isSample": isSample
                                        }})}
                                    >
                                        그림보기
                                    </button>
                                } */}
                            </div>
                            <br/>
                            {showPoem && <div style={{marginLeft:"30px"}}>
                                <p><b>{problemPoem && problemPoem.length > 1 && problemPoemTitle !== "NaN" && splitContent(problemPoemTitle)}</b></p>
                                {problemPoem && problemPoem.length > 1 && problemPoem.map(poem => {
                                    return (
                                        <div>{poem.trim().length>0 ? splitContent(poem) : <br/>}</div>
                                    )
                                })}
                            </div>}
                            <br/>
                        </div>
                    </div>
                </div>
                <br/>
            </div>
        );
    };
};

export default CategoryProblem;